import {
  PrepareRecordingArgs,
  PreparedRecording,
  PreparedRecordingController,
} from "@/store/audio/recording/prepared-recording-controller/types";
import { DateTime } from "luxon";

export class WebPreparedRecordingController implements PreparedRecordingController {
  prepareRecording({
    customVocabulary,
    audioRecordingId,
  }: PrepareRecordingArgs): PreparedRecording {
    return {
      audioRecordingId,
      customVocabulary: customVocabulary,
      wholeDesktopWindowId: Promise.resolve(""),
      recallUploadCredentials: Promise.resolve({ uploadToken: "", sdkUploadId: null }),
      expiresAt: DateTime.local().plus({ years: 1 }),
    };
  }
}
